import { Suspense } from "react";
import { Spin } from "antd";
import TopBar from "@/components/common/TopBar";
import QRCodeContent from "@/components/qrcode/QRCodeContent";

/**
 * QR Code Page
 * Displays recycling QR code for user
 *
 * Features:
 * - Shows user's QR code for cup recycling
 * - Displays user info and status
 * - TopBar navigation
 * - Long polling for QR code scanning
 */
export default function QRCodePage() {
  return (
    <div className="flex flex-col fixed top-0 left-0 right-0 bottom-0 w-full h-full overflow-hidden">
      {/* Static navbar - renders immediately */}
      <TopBar title="循環杯回收憑證" />

      {/* Dynamic content with Suspense boundary */}
      <Suspense
        fallback={
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center">
              <Spin size="large" />
              <p className="mt-4 text-gray-600">Loading QR code...</p>
            </div>
          </div>
        }
      >
        <QRCodeContent />
      </Suspense>
    </div>
  );
}
